"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiOptionIconEnum = void 0;
var MultiOptionIconEnum;
(function (MultiOptionIconEnum) {
    MultiOptionIconEnum["Eye"] = "eye";
    MultiOptionIconEnum["Trash"] = "trash";
    MultiOptionIconEnum["Warning"] = "warning";
})(MultiOptionIconEnum = exports.MultiOptionIconEnum || (exports.MultiOptionIconEnum = {}));
